<template>
<div class="grid">


<template v-if="loading">

<div class="col-6">

<div class="grid">

<div class="col-12">
<Skeleton  height="2.2rem" class="mb-5 mt-3"></Skeleton>
<Skeleton height="2rem" class="mb-3 mt-3"></Skeleton>
<Skeleton height="2rem" class="mb-3"></Skeleton>
<Skeleton height="2rem" class="mb-3"></Skeleton>
<Skeleton height="2rem" class="mb-2"></Skeleton>
</div>




</div>


</div>

<div class="col-6">
<Skeleton  height="18rem" class="mt-3"></Skeleton>
</div>
<!-- line chart --> 
 


</template>






<template v-if="!loading">
<div class="col-12 md:col-4">

<div class="grid">

<div class="col-12">

<h3 class="text-purple-500 mb-0" >{{inputfield.name}}</h3>
</div>

<div class="col-10"><h4 class="text-primary mb-0" >Hayır  </h4></div>
<div class="col-2"><Tag class="ml-2 mt-4" severity="danger" :value="pieData.datasets[0].data[0]" aria-label="Tabable Primary Tag" tabindex="0"></Tag></div>

<div class="col-10"><h4 class="text-primary mb-0" >Evet  </h4></div>
<div class="col-2"><Tag class="ml-2 mt-4" severity="success" :value="pieData.datasets[0].data[1]" aria-label="Tabable Primary Tag" tabindex="0"></Tag></div>





</div>

</div>

<div class="col-12 md:col-2"></div>

<!-- line chart --> 
<div class="col-12 md:col-3">
<Chart type="pie" :data="pieData" :options="pieOptions" />
</div>
<!-- line chart --> 




</template>




</div>
</template>

<script>
export default {

  name: 'PieChart',
  props:["inputfield"],
  data () {
    return {
      loading:true,
      pieData: {
            labels: [],
              datasets: [
              {
                  data: [],
                  backgroundColor: ["#dd4b39","#4dc247"],
              }
            ]
            },
      pieOptions: {
      plugins: {
          legend: {
              labels: {
                  color: '#495057'
              }
          }
      }
      },
    }
  },
  methods:{
    async changeBarData(data,labels,datasetlabel)
    {
        console.log(data)
        console.log(labels)
        this.loading = await true
        this.pieData.datasets[0].data = await data
        this.pieData.datasets[0].label = await datasetlabel
        this.loading = await false   
    }
  },
}
</script>

<style lang="css" scoped>
</style>